<template>
    <div v-if="userId">
        <BTooltip
            :target="targetId"
            placement="top"
            :html="true"
            :title="user.info.contact_name + ' (' + user.info.contact_tel + ')'"
        />
        
        <span
            :id="targetId"
              :style="{ color: user.role === 'sale' && user.online ? 'green' : (user.role === 'sale' ? 'red' : '') }"
              class="cursor-pointer"
              @click="viewUser(user.user_id)"
              v-if="user.role === 'sale'"
        >
            {{ user.info.company }}
        </span>
    </div>
    
    <div v-else>
        <span >{{ textEmpty }}</span>
    </div>
    
</template>

<script>
import {mapGetters} from 'vuex';
import {
    BTooltip,
} from 'bootstrap-vue-next';
export default {
    name: "position_user",
    
    components : {
        BTooltip
    },
    
    props: {
        userId: {
            type: [String, Number],
            required: true,
        },
        textEmpty: {
            type: String,
            required: true,
        },
    },
    
    methods: {
        viewUser() {
            let _href = '/kontrahenty/' + this.userId
            window.open(_href, '_blank');
        },
    },
    
    data() {
        return {
            _uidSuffix: Math.random().toString(36).slice(2, 9),
        }
    },
    
    computed: {
        ...mapGetters({
            'users': "reduction/getUsers",
            'reduction': 'reduction/getReduction'
        }),
        targetId() {
            return `user-pos_win-${this.user.user_id}-${this._uidSuffix}`
        },
        user() {
            const found = Array.isArray(this.users)
                ? this.users.find(u => String(u.user_id) === String(this.userId))
                : null;
            
            if (found) return found;
            
            return {
                online: false,
                info: {
                    contact_name: 'Невідомий користувач',
                    contact_tel: `id:${this.userId}`,
                    company: '',
                },
            };
        },
    },
}
</script>


<style scoped>

</style>